import AccountRow from "./AccountRow.js";

/**
 * Account report row generated as child of an account group.
 *
 */
export default class GeneratedAccountRow extends AccountRow {
	accept(visitor) {
		return visitor.visitGeneratedAccountRow(this);
	}

	isGenerated() {
		return true;
	}

	canBeReferenced() {
		return false;
	}

	canBeUsedInFormulas() {
		return false;
	}

	canBeSelected() {
		return false;
	}

	static getType() {
		return "GeneratedAccountRow";
	}
}
